<template>
    <div id="giftcard-container">
        <gift-card-content></gift-card-content>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss">
#giftcard-container {
    #service-content {
        margin: 0;
    }
    .giftcard-content {
        .vs-con-table {
            .vs-table--tbody {
                z-index: 0;
            }
            .vs-table {
                padding: 0 0.3rem;
                .vs-table--thead {
                    th {
                        .vs-table-text {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            text-align: center;
                        }
                    }
                }
            }
            .text-uppercase {
                font-size: 13px;
                color: #626262;
                // font-weight: normal;
            }

            tr {
                td {
                    padding: 12px;
                    &.has-import {
                        border-top-left-radius: 0 !important;
                    }
                }
            }

            .import-status {
                position: absolute; 
                // top: -20px;
                top: -18px;
                // top: -15px; 
                left: -1px; 
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
            }
        }
        .con-input-search {
            height: inherit;
            input {
                border: 1px solid #ccc;
                font-size: 14px;
                padding-left: 35px;
                min-height: 43px;
            }

            &.vs-table--search {
                i {
                    font-size: 1.2rem;
                }
            }
        }
        .giftcard-select{
            position: relative;
            margin-left: 17px;
            // width: 150px;
            // width: 200px;
            width: 175px;
            min-width: 170px;
            height: 41px;
            &.giftcard-select-type {
                width: 164px;
            }
            .charging-circle-img {
                position: absolute;
                top: 50%;
                left: 15px;
                transform: translateY(-50%);
                width: 17px;
                height: 17px;
                pointer-events: none;
            }
            .v-select {
                height: 43px;
                .vs__dropdown-toggle {
                    height: 100%;
                    border-radius: 8px;
                    background: #fff;
                    border: 1px solid #ccc;
    
                    .vs__selected {
                      color: #707070;
                      display: -webkit-box;
                      -webkit-line-clamp: 1;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      margin-top: 7px;
                      margin-right: 0;
                      padding-left: 40px;
                    }
    
                    .vs__open-indicator {
                      color: #AAA;
                      padding-right: 2px;
                    }
    
                    .vs__search {
                        flex-grow: 0;
                    }
                }
                .vs__dropdown-menu {
                  top: 110%;
                  border-radius: 8px;
                  border: 1px solid #ccc;
                  padding: 0;
                  // overflow: hidden;
                  &::-webkit-scrollbar, &::-webkit-scrollbar-track, &::-webkit-scrollbar-thumb {
                    border-top-right-radius: 8px !important;
                    border-bottom-right-radius: 8px !important;
                  }
    
                  li {
                    padding-top: 8px;
                    padding-bottom: 8px;
                    padding-left: 16px;
                    width: inherit;
                    overflow-x: auto;
                  }
                }
            }
        }

        .filter-date-picker {
            width: 170px;
            .mx-input {
                height: 43px;
                border-radius: 8px;
                box-shadow: none;
                // box-shadow: 2px 2px 5px rgba(0,0, 0, 0.1);
                border: 1px solid #ccc;
                // border: none;
                font-size: 1rem;
                // padding: 0.7rem 1.5rem;
                padding: 6px 40px;
                padding-right: 16px;
                // color: $primary;
    
                &::placeholder {
                //   color: $primary;
                  padding: 6px 10px;
                  padding-left: 0;
                }
            }
    
            .mx-icon-calendar, .mx-icon-clear {
                left: 16px;
                right: unset;
            }
    
            .mx-icon-clear {
              display: block;
              & + .mx-icon-calendar {
                display: none !important;
              }
            }
        }
        .giftcard-header {
            padding: 0 0.3rem;
        }

        .header-btn {
            height: 100%;
            min-height: 41px;
            margin-left: 17px;

            // &:last-child {
            //     margin-right: 17px;
            // }
            
            .vs-button--text {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            &.create-btn {
                padding: 0 1.3rem 0 1rem;
                min-width: 110px;
                .plus-square-icon {
                    width: 35px;
                    transform: translateY(3px);
                }
            }

            &.export-btn {
                padding: 0 1.3rem;
                .excel-icon {
                    width: 23px;
                }
            }

            &.import-btn {
                padding: 0 1.3rem;
                .import-icon {
                    width: 23px;
                }
                &.file-import-btn {
                    min-width: 150px;
                }
            }
        }

        @media (max-width: 1363px) {
            .giftcard-header {
                flex-direction: column;
                align-items: center;
                .left-header {
                    margin-bottom: 17px;
                }
            }
        }

        @media (max-width: 835px) {
            .giftcard-header {
                flex-direction: column;
                align-items: center;
                .left-header, .right-header {
                    // margin-bottom: 17px;
                    flex-direction: column;
                    align-items: center;
                    width: 100%;
                    margin-bottom: 0;
                    .con-input-search, .giftcard-select, .filter-date-picker, .date-filter {
                        width: 100%;
                        max-width: unset;
                        margin-left: unset;
                        margin-bottom: 17px;
                        .filter-date-picker {
                            margin: 0 !important;
                        }
                    }
                }
                .export-btn, .create-btn, .import-btn, .export-dropdown {
                    width: 100%;
                    margin-left: 0;
                    margin-bottom: 17px;
                }
                .export-dropdown {
                    margin-bottom: 0;
                }
            }
        }

        @media (max-width: 900px) {
            .giftcard-list-content-table {
                overflow: hidden;
                .vs-table--tbody-table {
                    min-width: 800px;
                }
            }
        }

        // @media (max-width: 1120px) {
        // @media (max-width: 1023px) {
        // @media (max-width: 1350px) {
        // @media (max-width: 1563px) {
        // @media (max-width: 1333px) {
        //     .giftcard-header {
        //         flex-direction: column;
        //         align-items: center;
        //         .left-header {
        //             margin-bottom: 17px;
        //         }
        //     }
        // }

        // @media (max-width: 1302px) {
        //     .giftcard-header {
        //         .left-header {
        //             flex-direction: column;
        //             align-items: center;
        //             .second-left-header {
        //                 margin-top: 17px;
        //             }
        //         }
        //     }
        // }
    }
}
.export-giftcard-dropdown-menu {
    width: auto !important;
    .vs-dropdown--menu {
        border-radius: 0;
    }
    .vs-dropdown--item-link {
        padding: 8px !important;

        .vs-button {
            padding: 0.75rem !important;
            min-width: 101px;
            &.download-btn {
                min-width: 166px;
            }
        }
    }

    .vs-dropdown--menu--after {
        display: none;
    }
}
</style>